import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { OnCallCenterDto, OnCallCentersService } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchOnCallCenters = (
  extraOptions?: UseQueryOptions<OnCallCenterDto[], unknown, OnCallCenterDto[], QueryKeys[]>
) => {
  return useQuery(
    [QueryKeys.fetchOnCallCenters],
    async () => {
      return OnCallCentersService.onCallCentersControllerFetchOnCallCenters();
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération des permanences');
      },
      ...extraOptions,
    }
  );
};
